export default {
  VIEW_LEGAL: "Legal - Viewed",
}
